import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Page } from '../../../models/page.model';
import { todayIso } from '../../../shared/date.util';
import { filenameFromContentDisposition } from '../../../shared/file-download';
import { KiAuditEintrag, KiAuditExportDatei } from './ki-audit.model';

@Injectable({ providedIn: 'root' })
export class KiAuditService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/v1/ki/audit`;

  seite(page: number, size: number): Observable<Page<KiAuditEintrag>> {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get<Page<KiAuditEintrag>>(this.baseUrl, { params });
  }

  exportieren(): Observable<KiAuditExportDatei> {
    return this.http.get(`${this.baseUrl}/export`, { responseType: 'blob', observe: 'response' }).pipe(
      map((response) => ({
        blob: response.body ?? new Blob(),
        dateiname: filenameFromContentDisposition(
          response.headers.get('Content-Disposition'),
          `ki-audit-${todayIso()}.csv`,
        ),
      })),
    );
  }
}
